import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import "./withdraw.css";

function WithDraw({ profile, bankCard, getProfile }) {
    const [bank, setBank] = useState(null);
    const [newMoney, setNewMoney] = useState(null);
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [payment, setPayment] = useState(null);
    
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();
    
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    
    const navigate = useNavigate();
    
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/bank/getBank`, {})
            .then((res) => {
                setBank(res.data.data);
            })
            .catch((err) => setBank(null));
            
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
        
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/paymentus`, {})
            .then((res) => {
                setPayment(res.data.data);
            })
            .catch((err) => console.log(err));
    }, [profile]);
    
    // Hàm che 4 số cuối của tài khoản ngân hàng
    const maskAccount = (stk) => {
        if (!stk) return "";
        if (stk.length <= 4) return "****";
        return stk.slice(0, -4) + "****";
    };
    
    const onSubmit = (data) => {
        // Lấy số điểm người dùng nhập vào (VD: 100)
        const inputPoint = Number(data.money.replaceAll(".", "").replaceAll(",", ""));
        
        // Nhân với 1000 để ra số tiền thật gửi lên server (VD: 100 * 1000 = 100000)
        const realMoney = inputPoint * 1000;

        // So sánh với số dư thật của profile
        if (realMoney > profile.money) {
            swal("Thất bại", "Số dư điểm không đủ", "error");
            return;
        }
        if (inputPoint <= 0 || isNaN(inputPoint)) {
            swal("Chú ý", "Vui lòng nhập số điểm hợp lệ", "warning");
            return false;
        }
        if (!data.paypwd) {
            swal("Chú ý", "Vui lòng nhập mật khẩu rút tiền", "info");
            return false;
        }
        if (realMoney < setting?.minrut) {
            swal("Chú ý", `Số điểm rút tối thiểu là ${(setting?.minrut / 1000).toLocaleString('vi-VN')} Điểm`, "warning");
            return false;
        }
        if (realMoney > setting?.maxrut) {
            swal("Chú ý", `Số điểm rút tối đa là ${(setting?.maxrut / 1000).toLocaleString('vi-VN')} Điểm`, "warning");
            return false;
        }
        
        const formData = {
            money: realMoney,
            type_payment: "RÚT",
            detail: bank[0]?.stk + " - " + bank[0]?.name_bank + " - " + bank[0]?.fullname,
            status_payment: "Pending",
            user: profile._id,
            paypwd: data.paypwd ? data.paypwd : ""
        };
        
        axios
            .post(`${process.env.REACT_APP_API_URL}/payment/withDraw`, formData)
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Tạo yêu cầu rút điểm thành công!",
                    icon: "success",
                    buttons: "OK"
                }).then(() => window.location.reload());
                getProfile();
            })
            .catch((err) => swal("Thất bại", err.response?.data?.message != "internal server error" ? err.response?.data?.message : "Đã xảy ra lỗi", "error"));
    };
    
    const [activeOption, setActiveOption] = useState(1);
    const handleOptionClick = (option) => {
        setActiveOption(option);
    };
    
    useEffect(() => {
        if (bankCard) {
            setActiveOption(2);
        }
    }, [bankCard]);
    
    // Hàm Thêm thẻ ngân hàng (Không load lại trang)
    const addBank = (data) => {
        if (data.name_bank == "" || data.stk == "" || data.fullname == "") {
            swal("Thông báo", "Vui lòng nhập đầy đủ thông tin (Tên NH, STK, Tên chủ thẻ)", "warning");
            return;
        }
        
        const formData = {
            name_bank: data.name_bank,
            stk: data.stk,
            fullname: data.fullname,
            user: profile._id
        };
        
        axios
            .post(`${process.env.REACT_APP_API_URL}/bank/create`, formData)
            .then((res) => {
                swal("Thành Công", "Ngân hàng đã được thêm thành công", "success");
                getProfile();
                
                // Fetch lại danh sách ngân hàng để cập nhật UI ngay lập tức
                axios
                    .get(`${process.env.REACT_APP_API_URL}/bank/getBank`, {})
                    .then((resBank) => {
                        setBank(resBank.data.data);
                    })
                    .catch((err) => setBank(null));
            })
            .catch((err) => swal("Thất bại", err.response?.data?.message != "internal server error" ? err.response?.data?.message : "Đã xảy ra lỗi", "error"));
    };

    return (
        <div className="withdraw-wrapper-new">
            
            {/* CSS TÙY CHỈNH */}
            <style>{`
                .withdraw-wrapper-new {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }
                
                /* Khu vực Menu Tabs */
                .withdraw-header-new {
                    display: flex;
                    border-bottom: 2px solid #f0f0f0;
                    margin-bottom: 25px;
                    justify-content: center; 
                }
                .menu-item-withdraw-new {
                    padding: 12px 25px;
                    font-size: 16px;
                    font-weight: 600;
                    color: #555;
                    cursor: pointer;
                    position: relative;
                    transition: 0.3s;
                }
                .menu-item-withdraw-new:hover, .menu-item-withdraw-new.active {
                    color: #d32f2f;
                }
                .menu-item-withdraw-new.active::after {
                    content: '';
                    position: absolute;
                    bottom: -2px;
                    left: 0;
                    width: 100%;
                    height: 2px;
                    background-color: #d32f2f;
                }

                .withdraw-grid-new {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    width: 100%;
                }
                .withdraw-left-pane {
                    width: 100%;
                    max-width: 800px;
                }

                /* CĂN CHỈNH FORM ĐỒNG ĐỀU NẰM NGANG */
                .form-aligned {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }
                .form-group-aligned {
                    display: flex;
                    align-items: center;
                }
                .form-group-aligned label {
                    width: 220px;
                    font-size: 15px;
                    font-weight: bold;
                    color: #333;
                    flex-shrink: 0;
                }
                .ipadd-new {
                    flex: 1;
                    max-width: 450px;
                    padding: 12px 15px;
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    font-size: 15px;
                    outline: none;
                    background: #fafafa;
                    transition: 0.3s;
                }
                .ipadd-new:focus {
                    border-color: #d32f2f;
                    background: #fff;
                }
                .btn-red-new {
                    width: max-content;
                    margin-left: 220px;
                    padding: 12px 40px;
                    background-color: #d32f2f;
                    color: #fff;
                    border: none;
                    border-radius: 6px;
                    font-weight: bold;
                    font-size: 16px;
                    cursor: pointer;
                    transition: 0.3s;
                }
                .btn-red-new:hover {
                    background-color: #b71c1c;
                }

                /* Mobile thu form thành cột dọc */
                @media (max-width: 600px) {
                    .form-group-aligned {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 8px;
                    }
                    .form-group-aligned label {
                        width: 100%;
                    }
                    .ipadd-new {
                        max-width: 100%;
                    }
                    .btn-red-new {
                        margin-left: 0;
                        width: 100%;
                    }
                }

                /* Khung thẻ ngân hàng đã liên kết */
                .bank-card-list {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    margin-bottom: 25px;
                    align-items: center;
                }
                .box-banking-new {
                    background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
                    border-radius: 12px;
                    padding: 20px 30px;
                    color: #fff;
                    position: relative;
                    width: 100%;
                    max-width: 500px;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
                    cursor: pointer;
                    transition: 0.3s;
                }
                .box-banking-new:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 6px 15px rgba(0,0,0,0.25);
                }
                .money_banking h3 { margin: 0 0 5px 0; font-size: 16px; text-transform: uppercase; }
                .money_banking h4 { margin: 0; font-size: 24px; letter-spacing: 2px; }
                .ctk-new {
                    margin-top: 20px;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: right;
                    text-transform: uppercase;
                }

                .noBackard {
                    text-align: center;
                    padding: 40px 20px;
                    background: #f9f9f9;
                    border: 1px dashed #ccc;
                    border-radius: 8px;
                    margin: 0 auto;
                    max-width: 500px;
                }
                .huongdan-new {
                    background: #fff3e0;
                    border-left: 4px solid #ff9800;
                    padding: 15px 20px;
                    border-radius: 4px;
                    margin-top: 30px;
                }
                .huongdan-new .title {
                    font-weight: bold;
                    color: #e65100;
                    margin-bottom: 10px;
                }
                .huongdan-new ul {
                    margin: 0;
                    padding-left: 20px;
                    color: #555;
                    line-height: 1.6;
                }
            `}</style>

            {profile && (
                <>
                    <div className="withdraw-header-new">
                        <div className={`menu-item-withdraw-new ${activeOption == 1 ? "active" : ""}`} onClick={() => handleOptionClick(1)}>
                            Rút điểm
                        </div>
                        <div className={`menu-item-withdraw-new ${activeOption == 2 ? "active" : ""}`} onClick={() => handleOptionClick(2)}>
                            Quản lý ngân hàng
                        </div>
                    </div>

                    <div className="withdraw-grid-new">
                        
                        <div className="withdraw-left-pane">
                            {/* TAB 1: RÚT TIỀN */}
                            {activeOption == 1 ? (
                                <div className="content-withdraw-new">
                                    {bank == null || bank.length === 0 ? (
                                        <div className="noBackard">
                                            <p style={{ fontSize: "16px", marginBottom: "15px", color: "#555" }}>Thẻ ngân hàng trống</p>
                                            <button className="btn-red-new" style={{ marginLeft: 0 }} onClick={() => handleOptionClick(2)}>
                                                Thêm Thẻ Ngân Hàng
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="bank-card-list">
                                                <div className="box-banking-new">
                                                    <div className="money_banking">
                                                        <h3>{bank[0]?.fullname}</h3>
                                                        <h4>{maskAccount(bank[0]?.stk)}</h4>
                                                    </div>
                                                    <div className="ctk-new">{bank[0]?.name_bank}</div>
                                                </div>
                                            </div>

                                            <form className="form-aligned" onSubmit={handleSubmit(onSubmit)}>
                                                <div className="form-group-aligned">
                                                    <label>Số dư có thể rút</label>
                                                    <b style={{ fontSize: "18px", color: "#d32f2f" }}>{Math.floor(profile.money / 1000).toLocaleString("vi-VN")} Điểm</b>
                                                </div>
                                                <div className="form-group-aligned">
                                                    <label>
                                                        Số điểm muốn rút<br/>
                                                        <small style={{ color: "#888", fontWeight: "normal", fontSize: "13px" }}>(1 Điểm = 1.000 VNĐ)</small>
                                                    </label>
                                                    <input
                                                        className="ipadd-new"
                                                        type="text"
                                                        value={newMoney || ""}
                                                        {...register("money")}
                                                        onClick={() => setNewMoney(null)}
                                                        onChange={(e) => {
                                                            const val = e.target.value.replaceAll(".", "");
                                                            if (!isNaN(val) && val !== "") {
                                                                setNewMoney(Number(val).toLocaleString('vi-VN'));
                                                            } else {
                                                                setNewMoney("");
                                                            }
                                                        }}
                                                        placeholder="Ví dụ rút 100 điểm thì nhập 100"
                                                    />
                                                </div>
                                                <div className="form-group-aligned">
                                                    <label>Mật khẩu rút tiền</label>
                                                    <input className="ipadd-new" type="password" {...register("paypwd")} placeholder="Nhập mật khẩu rút tiền..." />
                                                </div>
                                                <button type="submit" className="btn-red-new">
                                                    Xác nhận rút điểm
                                                </button>
                                            </form>
                                            
                                            <div className="huongdan-new">
                                                <div className="title">Chú ý</div>
                                                <ul>
                                                    <li>Lệnh rút tối thiểu là {(setting?.minrut / 1000).toLocaleString('vi-VN')} điểm.</li>
                                                    <li>Thông tin liên kết ngân hàng phải tuyệt đối chính xác.</li>
                                                    <li>Chúng tôi không chịu trách nhiệm cho sai sót liên quan đến việc điền sai tài khoản ngân hàng.</li>
                                                    <li>Để chỉnh sửa thông tin ngân hàng nếu bạn đã liên kết, vui lòng liên hệ CSKH.</li>
                                                </ul>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                /* TAB 2: QUẢN LÝ NGÂN HÀNG */
                                <div className="content-withdraw-new">
                                    {bank == null || bank.length === 0 ? (
                                        <form className="form-aligned" onSubmit={handleSubmit(addBank)}>
                                            <div className="form-group-aligned">
                                                <label>Tên ngân hàng</label>
                                                <input className="ipadd-new" type="text" {...register("name_bank")} placeholder="Ví dụ: Vietcombank, MBBank..." />
                                            </div>
                                            <div className="form-group-aligned">
                                                <label>Số tài khoản</label>
                                                <input className="ipadd-new" type="text" {...register("stk")} placeholder="Nhập số tài khoản..." />
                                            </div>
                                            <div className="form-group-aligned">
                                                <label>Tên chủ tài khoản</label>
                                                <input className="ipadd-new" type="text" {...register("fullname")} placeholder="Ví dụ: NGUYEN VAN A" />
                                            </div>

                                            <button type="submit" className="btn-red-new" style={{ marginTop: "10px" }}>
                                                Liên kết ngân hàng
                                            </button>
                                        </form>
                                    ) : (
                                        <>
                                            <div className="bank-card-list">
                                                {bank.map((item, index) => (
                                                    <div key={index} className="box-banking-new" onClick={() => swal("Chú ý", "Để chỉnh sửa thông tin ngân hàng vui lòng liên hệ CSKH", "info")}>
                                                        <div className="money_banking">
                                                            <h3>{item.fullname}</h3>
                                                            {/* Đã che 4 số cuối */}
                                                            <h4>{maskAccount(item.stk)}</h4>
                                                        </div>
                                                        <div className="ctk-new">{item.name_bank}</div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="huongdan-new">
                                                <div className="title">Chú ý</div>
                                                <ul>
                                                    <li>Thông tin liên kết ngân hàng phải tuyệt đối chính xác.</li>
                                                    <li>Chúng tôi không chịu trách nhiệm cho sai sót liên quan đến ngân hàng của bạn.</li>
                                                    <li>Để chỉnh sửa thông tin ngân hàng nếu bạn đã liên kết, vui lòng liên hệ CSKH.</li>
                                                </ul>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                        
                    </div>
                </>
            )}
        </div>
    );
}

export default WithDraw;